module.exports = __webpack_public_path__ + "img/icon-flag.db7bb664.svg";